<!-- 置頂工具 -->
<template>
  <div id="goTop">
    <div class="goTop" v-show="goTopShow" @click="goTop">
      <i class="fas fa-arrow-up goTopIcon"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'goTop',
  data () {
    return {
      scrollTop: '',
      goTopShow: false
    }
  },
  watch: {
    scrollTop () {
      if (this.scrollTop > 500) {
        this.goTopShow = true
      } else {
        this.goTopShow = false
      }
    }
  },
  methods: {
    handleScroll () {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (this.scrollTop > 500) {
        this.goTopShow = true
      }
    },
    goTop () {
      let timer = null
      let _that = this
      cancelAnimationFrame(timer)
      timer = requestAnimationFrame(function fn () {
        if (_that.scrollTop > 0) {
          _that.scrollTop -= 50
          document.body.scrollTop = document.documentElement.scrollTop =
            _that.scrollTop
          timer = requestAnimationFrame(fn)
        } else {
          cancelAnimationFrame(timer)
          _that.goTopShow = false
        }
      })
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style scoped lang="scss">
.goTop:hover .goTopIcon {
  color: rgba(51, 153, 255, 1);
}
.goTopIcon {
  font-size: 20px;
  color: rgba(51, 153, 255, 0.8);
}
/*-----------------------------------------------------------
！手機版！！手機版！！手機版！！小於576px！！手機版！！手機版！！手機版！
------------------------------------------------------------*/
@media screen and (max-width: 576px) {
  .goTop {
    position: fixed;
    right: 30px;
    bottom: 30px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #fff;
    padding: 7px;
    cursor: pointer;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.5);
    z-index: 4;
    i {
      font-size: 30px;
    }
  }
}
/*--------------------------------------------------------
！中間版！中間版！中間版！！577px~991px！！中間版！中間版！中間版！
---------------------------------------------------------*/
@media (min-width: 577px) and (max-width: 991px) {
  .goTop {
    position: fixed;
    right: 50px;
    bottom: 50px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #fff;
    padding: 8px;
    cursor: pointer;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.5);
    z-index: 4;
    i {
      font-size: 30px;
    }
  }
}
/*--------------------------------------------------------
！電腦版！！電腦版！！電腦版！！大於992px~1199px！！電腦版！！電腦版！！電腦版！
---------------------------------------------------------*/
@media (min-width: 992px) and (max-width: 1199px) {
  .goTop {
    position: fixed;
    right: 60px;
    bottom: 60px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: #fff;
    padding: 8px;
    cursor: pointer;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.5);
    z-index: 4;
    i {
      font-size: 40px;
    }
  }
}
/*--------------------------------------------------------
！螢幕版！！螢幕版！！螢幕版！！大於1200px！！螢幕版！！螢幕版！！螢幕版！
---------------------------------------------------------*/
@media screen and (min-width: 1200px) {
  .goTop {
    position: fixed;
    right: 60px;
    bottom: 60px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #fff;
    padding: 8px;
    cursor: pointer;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.5);
    z-index: 4;
    i {
      font-size: 50px;
    }
  }
}
</style>
